<template>
  <div class="riding-form" v-bind:terrain="terrain">
    <h3>Riding Style</h3>
    <fieldset class="riding-style-fields">

      <input class="ghosted" value="1" id="allmountain" type="radio" checked="checked" name="terrain" v-model="terrain">
      <label for="allmountain" class="button-radio-big">
        <strong>All mountain</strong>
        All-around capability. Great for a first board.
        <span class="checkmark"></span>
      </label>

      <input class="ghosted" value="3" id="freestyle" type="radio" name="terrain" v-model="terrain">
      <label for="freestyle" class="button-radio-big">
        <strong>Freestyle: Tricks & Jumps</strong>
        Geared for parks, rails and ramps.
        <span class="checkmark"></span>
      </label>

      <input class="ghosted" value="4" id="freeride" type="radio" name="terrain" v-model="terrain">
      <label for="freeride" class="button-radio-big">
        <strong>Freeride: Control & stability</strong>
        Stiff for speed, steeps, and out-of-bounds.
        <span class="checkmark"></span>
      </label>

      <input class="ghosted" value="2" id="powder" type="radio" name="terrain" v-model="terrain">
      <label for="powder" class="button-radio-big">
        <strong>Powder</strong>
        Stay afloat and in-control on deep powder.
        <span class="checkmark"></span>
      </label>

    </fieldset>
    <input type="checkbox" v-model="beginner" class="ghosted" id="beginner">
    <label for="beginner" class="pretty-checkbox-big">
      <div class="checkmark"><span class="vsprite-checkmark"></span></div>
      I'm a beginner
    </label>
  </div>
</template>


<script>
  import store from '../store/board-fitter-store.js';
  export default {
    computed: {
      terrain: {
        get: function () {
          return store.state.terrain
        },
        set: function (newValue) {
          store.commit('setTerrain', newValue);
        }
      },
      beginner: {
        get: function () {
          return store.state.beginner
        },
        set: function (newValue) {
          store.commit('setBeginner', newValue);
        }
      }
    }
  }
</script>